<template>
  <div class="input-wrap w-100">
    <label v-if="label !== 'none'" for=""
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
    </label>
    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <textarea
      :id="`textarea-${parentKey}${setKey}`"
      :name="setKey"
      :value="value"
      :placeholder="placeholder"
      @blur="updateValue"
      @input="autoExpandTextareaInput"
      maxlength="5000"
      rows="1"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true, default: null },
    setKey: { type: String, required: true },
    placeholder: { type: String, required: false },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    rows: { type: String, required: false, default: '3' },
    parentKey: { type: String, required: false, default: '' },
  },
  watch: {
    value() {
      this.autoExpandTextarea()
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input-emit', this.setKey, e.target.value)
    },
    autoExpandTextarea() {
      this.$nextTick(() => {
        const element = document.getElementById(
          `textarea-${this.parentKey}${this.setKey}`
        )
        element.style.height = 'auto'
        if (
          this.value === '' ||
          this.value === null ||
          this.value === undefined
        )
          return
        if (this.value.match(/\n/g) === null) return
        const lines = this.value.match(/\n/g).length + 1
        const lineHeight = parseInt(getComputedStyle(element).lineHeight)
        const ptval = parseInt(getComputedStyle(element).paddingTop)
        const pbval = parseInt(getComputedStyle(element).paddingBottom)
        element.style.height = lineHeight * lines + ptval + pbval + 'px'
      })
    },
    autoExpandTextareaInput() {
      const element = document.getElementById(
        `textarea-${this.parentKey}${this.setKey}`
      )
      element.style.height = 'auto'
      if (this.value !== '') {
        element.style.height = element.scrollHeight + 'px'
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.autoExpandTextarea()
    })
  },
}
</script>
<style lang="scss" scoped>
textarea {
  overflow: hidden;
  min-height: 80px;
}
</style>
